/**
 * 判断是否为数组
 * @param {Array} arr 数组
 */
function isArray(arr) {
  return Object.prototype.toString.call(arr) === '[object Array]'
}
/**
 * 深拷贝/深度克隆
 * @param {Object} Obj
 */
export default function deepClone(obj) {
  //常见“非”值，直接返回原来的值
  if ([null, undefined, NaN, false].includes(obj)) return obj
  // 基础数据类型，直接返回
  if (typeof obj !== 'object' && typeof obj !== 'function') return obj
  var o = isArray(obj) ? [] : {}
  for (let i in obj) {
    if (obj.hasOwnProperty(i)) {
      o[i] = typeof obj[i] === 'object' ? deepClone(obj[i]) : obj[i]
    }
  }
  return o
}



// WEBPACK FOOTER //
// ./packages/utils/deepClone.js